import { useMemo } from "react";
import ListPaginationFooter from "../../components/ui/ListPaginationFooter.jsx";
import { formatListPageSummary } from "../../utils/listPagination.js";

/**
 * Kopfzeilen-Text + Footer für Enterprise-Listen (fix 100, Seitenwechsel).
 */
export default function useListPaginationUi({
  loading,
  total,
  pagination,
  pages,
  setPage,
  debouncedSearch = "",
  suffix = "",
}) {
  const page = pagination?.page ?? 1;

  const summary = formatListPageSummary({
    loading,
    total,
    page,
    pages,
    searchActive: Boolean(String(debouncedSearch || "").trim()),
    suffix,
  });

  const showPagination = !loading && pages > 1;

  const footer = useMemo(
    () => (
      <ListPaginationFooter
        visible={showPagination}
        page={page}
        pages={pages}
        onPrev={() => setPage(page - 1)}
        onNext={() => setPage(page + 1)}
      />
    ),
    [showPagination, page, pages, setPage],
  );

  return { summary, footer, showPagination };
}
